import { render } from "./Header.vue?vue&type=template&id=6bc78ce8"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=6bc78ce8&lang=css"

import exportComponent from "C:\\JavaWorkSpace\\cbzbs-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__